import { Component, OnInit, Input } from '@angular/core';
import { DrawCanvasDefaults } from '../../../models/configuration/draw/annotation-defaults.model';
import { DrawParameterObj } from '../../../models/configuration/draw/annotation-defaults.model';
import { cfgDrawParameter } from '../../../models/configuration/draw/annotation-defaults.model';
import { TdoColorPickerEvent } from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import { DrawDefaultsService } from '../draw-defaults/draw-defaults.service';
import {ConfigurationService} from '../configuration.service';
import {TdoDropdownChange} from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-draw-canvas-tools',
  templateUrl: './draw-canvas-tools.component.html',
  styleUrls: ['./draw-canvas-tools.component.css']
})
export class DrawCanvasToolsComponent implements OnInit {
  ParamName = 'DEFAULT_CANVASTOOLS';
  GradientSteps = [];
  enumGradientStyles = [{name: 'Angle To LT', value: 0}, {name: 'Line L To R', value: 1}, {name: 'Line R to L', value: 2}, {name: 'Line T to B', value: 3}];
  startColor: string;
  endColor: string;
  defaultColor = '#ffffff';
  gradientStyle: number;
  gradientStep: number;
  width: number;
  height: number;
  public drawParameter: cfgDrawParameter;
  public drawCanvasDefaults: DrawCanvasDefaults;

  constructor(private drawDefaultService: DrawDefaultsService, public configurationService: ConfigurationService,  private snackBar: MatSnackBar) {
    // this.enumGradientStyles = Object.keys(this.drawGradientStyles).filter(f => !isNaN(Number(f)));
  }
  getDrawParameters(parameterName: string) {
    let promise = new Promise((resolve, reject) => {
      this.drawDefaultService.getDrawDefaults(parameterName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  ngOnInit(): void {
    for (let i = 1; i <= 255; i++) {
      const newSize = {
        value: i
      };
      this.GradientSteps.push(newSize);
    }

    this.getDrawParameters(this.ParamName)
      .then((result: cfgDrawParameter) => {
        if ( result === null) {
          this.setDefaultValues();
          this.drawCanvasDefaults = new DrawCanvasDefaults();
          this.saveDefaultValues();
        }
        else {
          this.drawParameter = result;
          this.drawCanvasDefaults = JSON.parse(this.drawParameter.ParameterValue);
          console.log('mtm drawCanvasDefaults ', this.drawCanvasDefaults);

          this.startColor = this.drawCanvasDefaults.startColor;
          this.endColor = this.drawCanvasDefaults.endColor;
          this.width = this.drawCanvasDefaults.width;
          this.height = this.drawCanvasDefaults.height;
          this.gradientStyle = this.drawCanvasDefaults.gradientStyle;
          this.gradientStep = this.drawCanvasDefaults.gradientStep;
        }

      }, err => {
        this.setDefaultValues();
        this.drawCanvasDefaults = new DrawCanvasDefaults();
        this.saveDefaultValues();
      });

  }

  setDefaultValues() {
    this.startColor = '#ff0000';
    this.endColor = '#ffffff';
    this.width = 600;
    this.height = 600;
    this.gradientStep = 1;
    this.gradientStyle = 1;

  }
  saveDefaultValues() {
    this.drawCanvasDefaults.startColor = this.startColor;
    this.drawCanvasDefaults.endColor = this.endColor;
    this.drawCanvasDefaults.width = this.width;
    this.drawCanvasDefaults.height = this.height;
    this.drawCanvasDefaults.gradientStyle = this.gradientStyle;
    this.drawCanvasDefaults.gradientStep = this.gradientStep;

  }

  onStartColorChange(event: TdoColorPickerEvent) {
    this.startColor = event.hex;
  }
  onEndColorChange(event: TdoColorPickerEvent) {
    this.endColor = event.hex;
  }
  onGradientStyleChange(e) {
    this.gradientStyle = e.value.value;
  }
  onGradientStepChange(e) {
    this.gradientStep = e.value.value;
  }
  async onSave(e) {
    this.saveDefaultValues();
    const drawParam = new DrawParameterObj();
    drawParam.parameterName = this.ParamName;
    const annDefaults = JSON.stringify(this.drawCanvasDefaults);
    drawParam.parameterValue = annDefaults;
    await this.drawDefaultService.saveDrawDefaults('00000000-0000-0000-0000-000000000000', drawParam).toPromise();
    this.createMessage('Configuration Saved', 'Success');
    this.configurationService.setClean();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  getStyle(gradientStyle: number) {
    const val = this.enumGradientStyles.find(p => p.value === gradientStyle);
    if (val) {
      return val;
    }
  }

  getStep(gradientStep: number) {
    const val = this.GradientSteps.find(p => p.value === gradientStep);
    if (val) {
      return val;
    }
  }

  dropdownChange($event: TdoDropdownChange) {
    if ($event.isUserInput) {
      this.configurationService.setDirty();
    }
  }
}
